<div class="upgrade-plan-modal">
  <ng-container
    *ngLet="{
      mode: mode$ | async,
      title: modalTitle$ | async,
      completePlanProduct: completePlanProduct$ | async,
      isSelectingPlan: isSelectingPlan$ | async
    } as data"
  >
    <div class="flex items-center justify-between">
      <div class="upgrade-plan-title">{{ data.title }}</div>

      <button
        mat-icon-button
        class="mat-button mat-icon-button transition-color"
        (click)="closeDialog()"
      >
        <i class="fa fas fa-close"></i>
      </button>
    </div>

    <mat-dialog-content>
      <div
        class="upgrade-plan-provider-preview"
        *ngIf="data.mode === ModalMode.ProviderPreview"
      >
        <div class="upgrade-plan-provider-preview-list">
          <div
            class="upgrade-plan-provider-preview-list-item"
            *ngFor="let item of providerPreviews"
            [ngClass]="item.class"
          >
            <div>
              <img
                [src]="item.icon"
                [alt]="item.title"
                class="upgrade-plan-provider-preview-list-item-icon"
              />

              <div class="upgrade-plan-provider-preview-list-item-title">
                {{ item.title }}
              </div>
              <div class="upgrade-plan-provider-preview-list-item-description">
                {{ item.description }}
              </div>
            </div>

            <div>
              <img
                [src]="item.image"
                [alt]="item.title"
                class="upgrade-plan-provider-preview-list-item-image"
              />
            </div>
          </div>
        </div>

        <div
          class="upgrade-plan-provider-preview-footer"
          *ngIf="data.mode === ModalMode.ProviderPreview"
        >
          <a
            href=""
            (click)="onPreviewProviderNetworkBackClick($event)"
            class="upgrade-plan-provider-preview-footer-back-link"
          >
            < Back to Plans</a
          >
        </div>
      </div>

      <ng-container *ngIf="data.mode === ModalMode.Plans">
        <div class="upgrade-plan-subtitle">
          {{ description }}
        </div>

        <div
          class="upgrade-plan-provider-preview-link"
          (click)="setMode(ModalMode.ProviderPreview)"
        >
          <div class="upgrade-plan-provider-preview-link-image-container">
            <img
              src="assets/dentist.svg"
              alt="Find a Dentist"
              class="upgrade-plan-provider-preview-link-image"
            />
          </div>

          <div class="upgrade-plan-provider-preview-link-content">
            <div class="upgrade-plan-provider-preview-link-title">
              Preview Provider Network
            </div>
            <div class="upgrade-plan-provider-preview-link-description">
              Want to learn more about the National Dental Provider Network?
              Preview here!
            </div>
          </div>

          <img
            src="assets/arrow-right-short.svg"
            alt="Preview Provider Network"
            class="upgrade-plan-provider-preview-link-arrow"
          />
        </div>
      </ng-container>

      <div
        class="upgrade-plan-list"
        *ngIf="data.mode === ModalMode.Plans || data.mode === ModalMode.Address"
      >
        <koa-upgrade-plan-list
          [availableUpgrades]="availableUpgrades"
          [selectedPlan]="selectedPlan"
          (modeChange)="setMode($event)"
        ></koa-upgrade-plan-list>
      </div>
    </mat-dialog-content>
  </ng-container>
</div>
